export default "__VITE_ASSET__i0jxkThS__"